import React, { Fragment } from 'react'
// STYLES
import { 
  FooterContainer, 
  PaginationBtnNumberPage, 
  PaginationBtnPreviousNext,
  PaginationDots,
  PaginationBtnContainer,
} from "../WidgetTable.styles"

const Pagination = ({
  pageIndex,
  pagesLength,
  // NAVIGATION
  gotoPage,
  canPreviousPage, 
  previousPage,
  canNextPage,
  nextPage,
  // STYLES
  paginationColor,
}) => {

  const filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter(page => page <= totalPages)
  }

  const getVisiblePages = (page, total) => {
    if (total < 7) {
      return filterPages([1, 2, 3, 4, 5, 6], total)
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total]
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total]
      } else {
        return [1, 2, 3, 4, 5, total]
      }
    }
  }

  const visiblePages = getVisiblePages(pageIndex + 1, pagesLength)
  
  return (
    <FooterContainer>
      <PaginationBtnContainer justifyContent="flex-end" width="30%">
        <PaginationBtnPreviousNext color={paginationColor} enabled={canPreviousPage} onClick={previousPage}>
          <i className="fas fa-caret-left"/>
        </PaginationBtnPreviousNext>
      </PaginationBtnContainer>
      <PaginationBtnContainer justifyContent="center" width="40%">
        {visiblePages.map((page, index, array) => {
          const indexPage = parseInt(page) - 1
          return (
            <Fragment key={index} >
              {array[index - 1] + 2 < page &&
                <PaginationDots color={paginationColor}>...</PaginationDots>
              }
              <PaginationBtnNumberPage
                onClick={() => gotoPage(indexPage)}
                selected={indexPage === pageIndex}
                color={paginationColor}
              >
                {page}
              </PaginationBtnNumberPage>
            </Fragment>
          )
        })}
      </PaginationBtnContainer>
      <PaginationBtnContainer justifyContent="flex-start" width="30%">
        <PaginationBtnPreviousNext color={paginationColor} enabled={canNextPage} onClick={nextPage}>
          <i className="fas fa-caret-right"/>
        </PaginationBtnPreviousNext>
      </PaginationBtnContainer>
    </FooterContainer>
  )
}

export default Pagination
